export const vendorFilterKey = "vendor"
export const classFilterKey = "classes"
export const departmentFilterKey = "departments"
export const finelineFilterKey = "finelines"
